var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 2.583a.75.75 0 0 1 .75.75v9.333a.75.75 0 0 1-1.5 0V8.75H3.083v3.916a.75.75 0 0 1-1.5 0V3.333a.75.75 0 0 1 1.5 0V7.25H8.25V3.333a.75.75 0 0 1 .75-.75M13.667 6.583a.75.75 0 0 1 .75.75v5.333a.75.75 0 0 1-1.5 0V10.75H11a.75.75 0 0 1-.75-.75V7.333a.75.75 0 0 1 1.5 0V9.25h1.167V7.333a.75.75 0 0 1 .75-.75"
  })));
};
export default Svg16;